import { FeedActions, FeedActionTypes } from '@core/store/actions/feed.actions';
import { FeedItem } from '@model';

export interface State {
    data: FeedItem[];
    loaded: boolean;
    loading: boolean;

}

export const initialState: State = {
    data: null,
    loaded: false,
    loading: false
};

export function reducer(state = initialState, action: FeedActions): State {
    switch (action.type) {
    case FeedActionTypes.LoadFeedData:
      return { ...state, loaded: false, loading: true };
    case FeedActionTypes.LoadFeedDataSuccess:
      return {
        ...state,
        loaded: true,
        loading: false,
        data: action.payload
      };


    case FeedActionTypes.ClearFeedData:
            return { ...state, data: null };
    }
    return state;
}

export const getFeed = (state: State) => state.data;
export const getFeedLoaded = (state: State) => state.loaded;